const TOKEN_KEY = 'dindin.auth.token';
const CUSTOMER_KEY = 'dindin.auth.customer';

export function readAuth() {
  try {
    const token = window.localStorage.getItem(TOKEN_KEY) || '';
    const rawCustomer = window.localStorage.getItem(CUSTOMER_KEY) || '';
    const customer = rawCustomer ? JSON.parse(rawCustomer) : null;
    return { token, customer };
  } catch {
    return { token: '', customer: null };
  }
}

export function writeAuth({ token, customer }) {
  try {
    if (token) window.localStorage.setItem(TOKEN_KEY, token);
    else window.localStorage.removeItem(TOKEN_KEY);
    if (customer) window.localStorage.setItem(CUSTOMER_KEY, JSON.stringify(customer));
    else window.localStorage.removeItem(CUSTOMER_KEY);
  } catch {
    // ignore storage failures (private mode / blocked)
  }
}

export function clearAuth() {
  writeAuth({ token: '', customer: null });
}

